var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 5 9",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.29041 8.12256C3.6361 8.45687 4.19485 8.45687 4.54054 8.12256C4.88623 7.78824 4.88623 7.24787 4.54054 6.91355L2.134 4.58618L4.54054 2.25966C4.88623 1.92535 4.88623 1.38412 4.54054 1.05066C4.19485 0.716349 3.6361 0.716349 3.29041 1.05066L0.2588 3.98168C0.0863995 4.14926 -0.000243294 4.3673 -0.000243314 4.58618C-0.000243334 4.80507 0.0863994 5.02395 0.2588 5.19068L3.29041 8.12256Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowLeft);
export default __webpack_public_path__ + "static/media/arrow-left.232b0140.svg";
export { ForwardRef as ReactComponent };